module.exports = __webpack_public_path__ + "static/media/redux.db086be8.svg";